// @ts-nocheck
import * as Types from '@instamenu/data-access-stats';

import gql from 'graphql-tag';
import { StatsOverviewFieldsFragmentDoc } from './charts/overview/queries.generated';
import { StatsTopItemFieldsFragmentDoc } from './charts/top-items/queries.generated';
import { StatsTopAddonFieldsFragmentDoc } from './charts/top-addons/queries.generated';
import { StatsHourlySalesFieldsFragmentDoc } from './charts/daily-sales/queries.generated';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type StatsQueryVariables = Types.Exact<{
  restaurantIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  startDate: Types.Scalars['ISO8601Date']['input'];
  endDate: Types.Scalars['ISO8601Date']['input'];
  startTime?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  endTime?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type StatsQuery = { __typename?: 'Query', stats: { __typename?: 'RestaurantStats', grossSales: number, loyaltyComps: number, grossSubtotal: number, netSales: number, netSalesRefunds: number, netTotal: number, giftCardSales: number, surchargeAmount: number, tax: number, tips: number, totalDiscounts: number, merchantFee: number, processingFee: number, deliveryFee: number, invoiceNetTotal: number, cashPayments: number, cashRoundingAdjustment: number, giftCardPayments: number, salesTaxWithheld: number, expectedPayout: number, numOrders: number, averageSale: number, averageTip: number, averageTipPercent: number, externalOrderTotalsBySource: Array<{ __typename?: 'ExternalOrderTotal', sourceLabel: string, amount: number }>, restaurants: Array<{ __typename?: 'Restaurant', id: string, hasActiveStreamLocationConnection: boolean }>, topItems: Array<{ __typename?: 'ItemStats', amount: number, discount: number, itemGroupName?: string | null, name: string, quantity: number }>, topAddons: Array<{ __typename?: 'ItemStats', amount: number, name: string, quantity: number }>, hourlySales: Array<{ __typename?: 'HourlySales', netSales: number, tips: number, hour: number }> } };


export const StatsDocument = gql`
    query Stats($restaurantIds: [ID!]!, $startDate: ISO8601Date!, $endDate: ISO8601Date!, $startTime: Int, $endTime: Int) {
  stats(
    restaurantIds: $restaurantIds
    startTime: $startTime
    endTime: $endTime
    startDate: $startDate
    endDate: $endDate
  ) {
    ...statsOverviewFields
    ...statsTopItemFields
    ...statsTopAddonFields
    ...statsHourlySalesFields
  }
}
    ${StatsOverviewFieldsFragmentDoc}
${StatsTopItemFieldsFragmentDoc}
${StatsTopAddonFieldsFragmentDoc}
${StatsHourlySalesFieldsFragmentDoc}`;

export function useStatsQuery(options: Omit<Urql.UseQueryArgs<StatsQueryVariables>, 'query'>) {
  return Urql.useQuery<StatsQuery, StatsQueryVariables>({ query: StatsDocument, ...options });
};